// Action Types
const TRANSITION_AUTH_MODAL = 'TRANSITION_AUTH_MODAL';

// States
export const AUTH_MODAL_CLOSED = 'AUTH_MODAL_CLOSED';
export const AUTH_MODAL_ENTRY = 'AUTH_MODAL_ENTRY';
export const AUTH_MODAL_SIGNIN = 'AUTH_MODAL_SIGNIN';
export const AUTH_MODAL_SIGNUP = 'AUTH_MODAL_SIGNUP';
export const AUTH_MODAL_ACCOUNT_EXISTED = 'AUTH_MODAL_ACCOUNT_EXISTED';
export const AUTH_MODAL_ACCOUNT_NOT_FOUND = 'AUTH_MODAL_ACCOUNT_NOT_FOUND';
export const AUTH_MODAL_ERROR = 'AUTH_MODAL_ERROR';

const allStates = Object.freeze([
  AUTH_MODAL_CLOSED,
  AUTH_MODAL_ENTRY,
  AUTH_MODAL_SIGNIN,
  AUTH_MODAL_SIGNUP,
  AUTH_MODAL_ACCOUNT_EXISTED,
  AUTH_MODAL_ACCOUNT_NOT_FOUND,
  AUTH_MODAL_ERROR,
]);

// Action Creators
export function openAuthModal() {
  return {
    type: TRANSITION_AUTH_MODAL,
    payload: AUTH_MODAL_ENTRY,
  };
}

export function closeAuthModal() {
  return {
    type: TRANSITION_AUTH_MODAL,
    payload: AUTH_MODAL_CLOSED,
  };
}

export function showSigninModal() {
  return {
    type: TRANSITION_AUTH_MODAL,
    payload: AUTH_MODAL_SIGNIN,
  };
}

export function showSignupModal() {
  return {
    type: TRANSITION_AUTH_MODAL,
    payload: AUTH_MODAL_SIGNUP,
  };
}

export function showAccountExistedModal() {
  return {
    type: TRANSITION_AUTH_MODAL,
    payload: AUTH_MODAL_ACCOUNT_EXISTED,
  };
}

export function showAccountNotFoundModal() {
  return {
    type: TRANSITION_AUTH_MODAL,
    payload: AUTH_MODAL_ACCOUNT_NOT_FOUND,
  };
}

export function showAuthErrorModal() {
  return {
    type: TRANSITION_AUTH_MODAL,
    payload: AUTH_MODAL_ERROR,
  };
}

// Reducer
export default function reducer(state = AUTH_MODAL_CLOSED, action) {
  return action.type === TRANSITION_AUTH_MODAL && allStates.includes(action.payload) ? action.payload : state;
}
